import tw from 'twin.macro';

export const H1 = tw.h1`
text-[28px] leading-[34px] mt-4 mb-[15px] font-serif font-bold text-white
`;
export const H2 = tw.h2`
text-[28px] leading-[34px] mt-4 mb-[15px] font-serif font-bold text-white
`;
